// Constants for filter types
export const FILTER_TYPES = {
  SEARCH: 'searchText',
  FULFILLMENT_CHANNEL: 'selectedFulfillmentChannel',
  STATUS: 'selectedStatus',
  SELLER_ACCOUNT: 'selectedSellerAccount'
};

// Default filter values
export const DEFAULT_FILTER_VALUES = {
  [FILTER_TYPES.SEARCH]: '',
  [FILTER_TYPES.FULFILLMENT_CHANNEL]: 'all',
  [FILTER_TYPES.STATUS]: 'all',
  [FILTER_TYPES.SELLER_ACCOUNT]: 'all'
};

// Validate filter type
export const isValidFilterType = (filterType) => {
  return Object.values(FILTER_TYPES).includes(filterType);
};

// Filter utilities
export const FilterManager = {
  getDefaultFilters: () => ({ ...DEFAULT_FILTER_VALUES }),
  
  isFilterActive: (value, defaultValue) => {
    // Handle selectedSellerAccount special case
    if (defaultValue === 'all' && Array.isArray(value)) {
      return value.length > 0;
    }
    
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return value && value !== defaultValue;
  },
  
  getActiveFiltersCount: (filters) => {
    let count = 0;
    
    Object.keys(DEFAULT_FILTER_VALUES).forEach(key => {
      if (FilterManager.isFilterActive(filters[key], DEFAULT_FILTER_VALUES[key])) {
        count++;
      }
    });
    
    return count;
  },
  
  hasChanges: (localFilters, appliedFilters) => {
    return Object.keys(DEFAULT_FILTER_VALUES).some(key => {
      const local = localFilters[key];
      const applied = appliedFilters[key];
      
      // Special handling for selectedSellerAccount (array vs string)
      if (key === 'selectedSellerAccount') {
        const localNormalized = Array.isArray(local) ? local : (local === 'all' ? [] : [local]);
        const appliedNormalized = Array.isArray(applied) ? applied : (applied === 'all' ? [] : [applied]);
        return JSON.stringify(localNormalized.sort()) !== JSON.stringify(appliedNormalized.sort());
      }
      
      if (Array.isArray(local) && Array.isArray(applied)) {
        return JSON.stringify(local.sort()) !== JSON.stringify(applied.sort());
      }
      
      return local !== applied;
    });
  }
};